<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M2 0.5H30C30.8284 0.5 31.5 1.17157 31.5 2V30C31.5 30.8284 30.8284 31.5 30 31.5H2C1.17157 31.5 0.5 30.8284 0.5 30V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
      stroke="#EBEFF7"
    />
    <path
      d="M22.6842 13.3998L18.5996 9.31551C18.4996 9.21549 18.3809 9.13614 18.2502 9.082C18.1195 9.02786 17.9795 9 17.8381 9C17.6966 9 17.5566 9.02786 17.4259 9.082C17.2953 9.13614 17.1765 9.21549 17.0765 9.31551L13.4671 12.9367C12.7497 12.7119 11.1115 12.4406 9.40204 13.8211C9.28421 13.9159 9.18766 14.0344 9.11866 14.169C9.04966 14.3035 9.00977 14.4511 9.00158 14.6021C8.99339 14.7531 9.01709 14.9041 9.07113 15.0453C9.12516 15.1865 9.20834 15.3148 9.31522 15.4217L12.5673 18.6727L9.69616 21.5421C9.59513 21.6431 9.53837 21.7802 9.53837 21.9231C9.53837 22.066 9.59513 22.203 9.69616 22.304C9.79719 22.4051 9.93421 22.4618 10.0771 22.4618C10.22 22.4618 10.357 22.4051 10.458 22.304L13.3271 19.4327L16.5772 22.683C16.6771 22.7833 16.7958 22.863 16.9265 22.9174C17.0573 22.9718 17.1974 22.9998 17.339 23C17.3646 23 17.3895 23 17.4151 23C17.5686 22.9894 17.718 22.9458 17.8532 22.8723C17.9883 22.7988 18.1061 22.697 18.1985 22.5739C19.5203 20.8172 19.3931 19.3889 19.0862 18.5354L22.6848 14.923C22.7848 14.8229 22.8641 14.7042 22.9182 14.5735C22.9723 14.4428 23.0001 14.3027 23 14.1612C22.9999 14.0198 22.972 13.8798 22.9178 13.7491C22.8636 13.6184 22.7842 13.4998 22.6842 13.3998ZM21.9223 14.1617L18.0679 18.0293C17.9883 18.1092 17.9358 18.2121 17.9178 18.3234C17.8998 18.4348 17.9172 18.5489 17.9676 18.6499C18.6043 19.924 17.8465 21.2473 17.339 21.9224L10.0771 14.6591C10.8901 14.0035 11.6681 13.8306 12.2631 13.8306C12.6406 13.8254 13.015 13.8995 13.3621 14.048C13.4634 14.0987 13.5781 14.1161 13.6898 14.0979C13.8016 14.0796 13.9048 14.0266 13.9847 13.9463L17.8384 10.0768L21.9223 14.1611V14.1617Z"
      fill="#696F79"
    />
  </svg>
</template>

<script>
export default {
  name: 'SquarePinIcon'
};
</script>

<style scoped>

</style>
